import {
  createPlugin,
  createApiFactory,
  configApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { pdpLoggerApiRef, PdpLoggerClient } from './api';

export const pdpLoggerFrontendPlugin = createPlugin({
  id: 'pdp-logger-frontend',
  apis: [
    createApiFactory({
      api: pdpLoggerApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new PdpLoggerClient({ configApi, identityApi }),
    }),
  ],
});
